module.exports = __webpack_public_path__ + "img/svg - only person.f3dfe20e.svg";